import React from "react";
import ErrorMessage from "./ErrorMessage";
import ExpiredChallenge from "./ExpiredChallenge";

const WorkChallenge: React.FC<any> = ({
  challengeBySlug,
  submitChallenge,
  handleChange,
  errorMessage,
}) => {
  return (
    <>
      {challengeBySlug.data.active ? (
        <div className="d-flex flex-column action-wrap">
          {!challengeBySlug.data.completed ? (
            <>
              <label htmlFor="">SUBMIT YOUr work</label>
              <input
                type="text"
                name="formValue"
                id="formValue"
                placeholder={`Paste the link to your ${
                  challengeBySlug.data.value ? challengeBySlug.data.value : ""
                } work`}
                onChange={handleChange}
              />
              <button
                onClick={() => submitChallenge()}
                className="challenge-submit d-flex justify-content-center align-content-center"
              >
                SUBMIT
              </button>
              <ErrorMessage errorMessage={errorMessage} />
            </>
          ) : (
            <>
              <div className="d-flex flex-column action-wrap">
                <h4 className="mb-0">YOUr WORK</h4>
                <p>
                  <a href={challengeBySlug.data.submission.work}>
                    {challengeBySlug.data.submission.work}
                  </a>
                </p>
              </div>
            </>
          )}
        </div>
      ) : (
        <ExpiredChallenge />
      )}
    </>
  );
};

export default WorkChallenge;
